module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNS40NDgiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNS40NDggMTYiPjxkZWZzPjxzdHlsZT4uYXtmaWxsOiNhOGIxYmY7fTwvc3R5bGU+PC9kZWZzPjxwYXRoIGNsYXNzPSJhIiBkPSJNMTYuMiwxNC41NzNsLTMuODA4LTMuOTYxQTYuNDU3LDYuNDU3LDAsMSwwLDcuNDQ0LDEyLjkyYTYuMzkxLDYuMzkxLDAsMCwwLDMuNy0xLjE2OWwzLjgzNywzLjk5MUEuODQzLjg0MywwLDEsMCwxNi4yLDE0LjU3M1pNNy40NDQsMS42ODVBNC43NzUsNC43NzUsMCwxLDEsMi42NjksNi40Niw0Ljc4LDQuNzgsMCwwLDEsNy40NDQsMS42ODVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMC45ODQpIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/search.svg
// module id = ysJu
// module chunks = 1